<template>
	<div class="relative h-[90vh] md:h-[90vh] w-[95%] md:w-[93%] lg:w-[85%] xl:w-[80%] mx-auto flex flex-col md:flex-row items-center justify-center rounded-2xl p-4 shadow-2xl pair-bg overflow-hidden">
		<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkLogo : lightLogo" alt="Logo" class="absolute top-6 left-6 w-36 h-auto md:w-44"/>
		<div class="mt-8">
			<div class="flex flex-col items-center justify-center">
				<h2 class="text-2xl md:text-3xl lg:text-4xl font-archivomedium md:mt-4 mt-6 mb-4 text-center text-[var(--text-color)]">
					Welcome to Cardware Wallet
				</h2>
				<p class="mb-6 text-sm md:text-md text-center font-archivolight text-[var(--secondary-text-color)] px-6">
					Pair your Cardware by scanning the QR codes on the device with your mobile, laptop or desktop camera.
				</p>
				<button @click="startPairing" class="bg-transparent font-archivoregular text-[var(--accent-color)] border border-[var(--accent-color)] py-3 px-8 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 mb-6 shadow-inner">
				Pair Device
				</button>
			</div>
			<div class="flex flex-shrink justify-center">
				<transition name="fade">
					<img :src="currentImages[currentImageIndex]" alt="Device Pairing" class="w-3/4 md:w-5/12 lg:w-6/12 h-auto ml-10">
				</transition>
			</div>
			<div class="flex flex-col items-center justify-center">
				<p class="text-sm text-[var(--secondary-text-color)] font-archivolight">See our <a href="https://docs.cardwarewallet.com/cardware-wallet-documentation/getting-started" target="_blank" rel="noopener noreferrer" class="text-sm font-archivolight text-[var(--accent-color)]">Guides</a> for more information</p>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {ref, onMounted, onBeforeUnmount, computed} from 'vue';
	import PhonePairing from '../assets/MobilePairing3.png';
	import LaptopPairing from '../assets/DesktopPairing3.png';
	import PhonePairingOrange from '../assets/MobilePairingOrange3.png';
	import LaptopPairingOrange from '../assets/DesktopPairingOrange3.png';
	import lightLogo from '../assets/CWWLogo.png';
	import darkLogo from '../assets/LogoWhite1.png';

	let carouselInterval = null;
	const lightImages = [PhonePairing, LaptopPairing];
	const darkImages = [PhonePairingOrange, LaptopPairingOrange];
	const currentImageIndex = ref(0);

	const props = defineProps({
		callback: { type: Function, required: true },
		currentTheme: { type: String, default: 'light' }
	});

	const currentImages = computed(() => {
		return (props.currentTheme === 'dark' || props.currentTheme === 'navy') ? darkImages : lightImages;
	});

	onMounted(async () => {
		carouselInterval = setInterval(() => {
			currentImageIndex.value = (currentImageIndex.value + 1) % currentImages.value.length;
		}, 3000);
	});

	onBeforeUnmount(() => {
		clearInterval(carouselInterval);
	});

	const startPairing = () => {
		props.callback();
	}
</script>

<style scoped>


	.lightTheme-bg {
		background: var(--bg-color);
	}

	.pair-bg {
		background: var(--main-bg-color);
	}
	.popup-bg {
		background: var(--popup-bg-color);
	}
	
</style>